import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createPortal } from "react-dom";
import logingImg from "assets/img/loginImage.jpg";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import ImgContainer from "components/shared/Image";
import { LeftGrid, RightGrid, StyledInput, StyledTitle } from "./sendOtp.style";
import { addNameSchema } from "validations";
import { addedNameRequest } from "api/requests";
import LoadingPartCM from "components/shared/PartLoading";
import {Helmet} from "react-helmet";

export default function SendName() {
  const navigate = useNavigate();
  const { request, loading } = useHttp(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addNameSchema),
  });

  const onSubmitName = async (values) => {
    const transformedData = { full_name: values.full_name };
    let res = await request({
      url: addedNameRequest,
      values: transformedData,
    });

    if (res) {
      navigate("/");
    }
  };

  return createPortal(
    <>
      {/* {loading && <LoadingCM />} */}
      <Helmet>
        <title>ورود / ثبت نام - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100vh", direction: "ltr !important" }}
      >
        <RightGrid item lg={6} md={6} sm={6} xs={12}>
          <div style={{ minHeight: "400px" }}>
            <StyledTitle variant="h4" alignSelf="center">
              ثبت نام
            </StyledTitle>
            <StyledInput
              id="full_name"
              label="نام و نام خانوادگی"
              fullWidth
              {...register("full_name")}
              error={Boolean(errors["full_name"])}
              helperText={errors["full_name"]?.message}
              style={{ textAlign: "center" }}
              InputProps={{
                readOnly: loading ? true : false,
              }}
            />
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmitName)}
              fullWidth
              style={{ height: "45px" }}
              disabled={loading ? true : false}
            >
              {loading ? <LoadingPartCM /> : "ثبت"}
            </Button>
          </div>
        </RightGrid>

        <LeftGrid item sm={6} xs={6}>
          <ImgContainer
            src={logingImg}
            alt="لوگو"
            // objectFit="contain"
            width="Auto"
            height="100%"
          />
        </LeftGrid>
      </Grid>
    </>,
    document.getElementById("login")
  );
}
